import React from 'react';

/**
 * Gauge Chart Component
 * Visual circular gauge for scores
 */
const GaugeChart = ({ 
  score, 
  maxScore = 100, 
  size = 200, 
  label = '', 
  color = 'primary' 
}) => {
  const percentage = (score / maxScore) * 100;
  const radius = (size - 20) / 2;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;

  const colorClasses = {
    primary: 'text-primary-500',
    secondary: 'text-secondary-500',
    green: 'text-green-500',
    blue: 'text-blue-500',
    yellow: 'text-yellow-500',
    red: 'text-red-500'
  };

  const colorClass = colorClasses[color] || colorClasses.primary;

  return (
    <div className="flex flex-col items-center">
      <div className="relative" style={{ width: size, height: size }}>
        <svg className="transform -rotate-90" width={size} height={size}>
          {/* Background circle */}
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            stroke="currentColor"
            strokeWidth="10"
            fill="none"
            className="text-slate-700"
          />
          {/* Progress circle */}
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            stroke="currentColor"
            strokeWidth="10"
            fill="none"
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
            strokeLinecap="round"
            className={`${colorClass} transition-all duration-1000 ease-out`}
          />
        </svg>
        
        {/* Center text */}
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <div className="text-4xl font-bold text-slate-100">
            {Math.round(percentage)}%
          </div>
          <div className="text-sm text-slate-400 mt-1">
            {score}/{maxScore}
          </div>
        </div>
      </div>
      
      {label && (
        <div className="mt-4 text-center">
          <p className="text-slate-300 font-medium">{label}</p>
        </div>
      )}
    </div>
  );
};

export default GaugeChart;
